import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";

export const styles = ({spacing, palette}: Theme) => createStyles({
    page: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
    },
    container: {
        flexGrow: 1,
        maxWidth: 1024,
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%"
    }
});


// WEBPACK FOOTER //
// ./src/pages/Page/Page.style.tsx